/*
 * @Author: Gaho
 * @Date: 2024-03-06 10:19:30
 * @LastEditors: Merlin
 * @LastEditTime: 2025-03-13 11:54:20
 * @Description: 
 */
import { asyncEmit } from '@/utils/socket';
import { useAmountMemoryStore } from '~/stores/cansino/amountMemory';
export interface cicleStateTypes {
    name: "BETTING" | "START" | "STOP_BETTING" | "SHOW_RESULT" | "PREPARING_NEXT_ROUND",
    end: number
}
export interface circleResultTypes {
    win_sector: string
}
export const useCircleSocket = (rootPath: string) => {
    // 下注
    const EMIT_CIRCLE_BET = (
        data: {
            amount: string;
            frontID: number;
            sector: number;
        },
        callback: any,
    ) => {
        socket.emit(`${rootPath}.circle.bet`, data, callback);
    };
    // 实时接收下注状态
    const ON_CIRCLE_STATE = (
        callback: (res: cicleStateTypes) => any,
    ) => {
        const sChannel = `${rootPath}.circle.state`;
        socket.on(sChannel, callback);
        return () => {
            import.meta.dev && console.log('Channel closed:', sChannel);
            socket.off(sChannel, callback); 
        };
    };
    // 接收游戏下注结果
    const ON_CIRCLE_RESULT = (
        callback: (res: circleResultTypes) => any,
    ) => {
        const sChannel = `circleresult`;
        socket.on(sChannel, callback);
        return () => {
            import.meta.dev && console.log('Channel closed:', sChannel);
            socket.off(sChannel, callback); 
        };
    };
    // 获取历史下注数据
    const EMIT_CIRCLE_HISTORY = (
        data: {},
        callback: any,
    ) => {
        socket.emit(`${rootPath}.circle.history`, data, callback);
    };
    // 获取circle round数据
    const EMIT_CIRCLE_ROUNDINFO = (
        data: {
            roundNum: number
        },
        callback: any,
    ) => {
        socket.emit(`${rootPath}.circle.roundInfo`, data, callback);
    };
    // 退出circle游戏 （此接口与 EMIT_GAME_EXIT 重复了）
    // const EMIT_CIRCLE_EXIT = (
    //     data: {},
    //     callback: any,
    // ) => {
    //     socket.emit(`${rootPath}.circle.exit`, data, callback);
    // };
    return {
        EMIT_CIRCLE_BET,
        ON_CIRCLE_STATE,
        EMIT_CIRCLE_HISTORY,
        ON_CIRCLE_RESULT,
        EMIT_CIRCLE_ROUNDINFO,
        // EMIT_CIRCLE_EXIT,
    }
}
